import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { Button, Input } from 'antd';
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import { GET_USERS } from "graphql/query/user-gql";
import { SUBCONTRACTOR_SYNC_USERS } from "graphql/mutation/subcontractor-gql";

import Subcontractor from 'components/subcontractor';
import Users from "components/users";
import { Tables } from "components/layout";
import { ModalStandard, Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";

const { Search } = Input;

const basePath = Subcontractor.Const.basePath;
const tableHelper = Subcontractor.Helpers.TableUsers;


const SubcontractorsUsersSubPage = ({ subcontractor }) => {

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Subcontractors" }).props.children,
            path: `${ basePath }`
        },
        {
            label: subcontractor?.title,
            path: `${ basePath }/${ subcontractor?.id }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Users" }).props.children,
            path: `${ basePath }/${ subcontractor?.id }${ Users.Const.basePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`${ basePath }/${ subcontractor.id }/users/page/:pageNum`);

    const subcontractorUsers = { column: 'SUBCONTRACTOR_ID', operator: "EQ", value: parseInt(subcontractor.id) }
    const [ searchText, setSearchText ] = useState("");

    
    return (
        <Tables.Main
            model="users"
            query={ GET_USERS }
            varSet={ { perPage: 30 } }
            currentObj={ subcontractor }
            routeUrl={ `${ basePath }/${ subcontractor.id }/users` }
            currentPage={ match ? parseInt(match.params.pageNum) : 1 }
            searchText={ searchText }
            objFilter={ subcontractorUsers }
            tableHelper={ tableHelper }
        >
            <div className="table-action-bar">

                <div className="col">
                    <Search
                        className="filter-search"
                        prefix={ <SearchOutlined /> }
                        placeholder={ Localize({ children: "SEARCH.Input_Placeholder_Table_User" }).props.children }
                        onChange={ (e) => setSearchText(e.target.value) }
                    />
                </div>

                <div className="col">
                    <ModalStandard
                        width={ 380 }
                        extraClass={ 'modal-form' }
                        modalButton={
                            <Button
                                type="primary">
                                <PlusOutlined /> Add user to group
                            </Button>
                        }>
                        <strong className="modal-title">Add users</strong>

                        <Users.Forms.Add
                            propsObj={ {
                                query: GET_USERS,
                                queryVar: {
                                    first: 10000,
                                    where: subcontractorUsers
                                },
                                mutation: SUBCONTRACTOR_SYNC_USERS,
                                mutationName: "subcontractorSyncToUsers",
                                model: "subcontractor_id",
                                modelID: subcontractor?.id,
                            }
                            } />
                    </ModalStandard>
                </div>
            </div>
        </Tables.Main>
    );
};

export default SubcontractorsUsersSubPage;
